import { useRef, useState } from 'react'
import axios from 'axios';

import{    
  UserIcon,
  EnvelopeIcon,
  LockClosedIcon
} from "@heroicons/react/24/outline"
import { LinearProgress } from '@mui/material';
import useUser from '../../hooks/useUser';
import { useNavigate } from 'react-router-dom';

function Login() {  
    
    const {user, setUser} = useUser();   
    
    const navigate = useNavigate()
    console.log('Login page called');    
    const username = useRef(null);
    const password = useRef(null);  
    
    //loading
    const [loading, setLoading] = useState(false)
    const [showError, setShowError] = useState(false)
    const [errorMsg, setErrorMsg] = useState("")
    
    const DoLogin = async e => {            
        e.preventDefault()
        setShowError(false)
        console.log("Login->DoLogin", process.env.REACT_APP_LOGIN_END_POINT)    
        setLoading(true)
        const result = await axios.post(process.env.REACT_APP_LOGIN_END_POINT,            
            {
                user_agent:"web",
                def_comp:"premium",
                user_name:username.current.value,
                password:password.current.value,          
            },
            {
                headers: {
                    'Content-Type': 'application/json'                                        
                },
            }            
        ).then( async function(response){            
            setLoading(false)
            if(response)
            {                
                setUser(response.data)
                navigate("/dashboard")
                console.log("Login->DoLogin->response", response);   
                console.log("Login->DoLogin->response->token", response.data.token);                   
            }
        })
        .catch(function(error){
            setLoading(false)
            setShowError(true)
            setErrorMsg(error?.response?.data)
            console.log("error->", error);
        })
    }            
    return (        
        <div className="flex h-screen">            
            <div className='flex w-2/5 bg-slate-400 h-full items-center'>                            
                <div className='rounded-full w-1/2'>                    
                    <img className='rounded-full ml-3' width='80%' src="/logo.png" />
                </div>                                
                <div className='text-7xl w-1/2 text-white'>Welcome back!</div>
            </div>            
            <div className='flex justify-center items-center w-3/5 '>                
                <div className="flex flex-col items-center justify-center py-2 mt-10 bg-white p-10 shadow-2xl rounded-2xl border-t-4 border-orange-500">                          
                    <div className="p-5">                
                        <form  onSubmit={DoLogin}>
                            <div>                            
                            </div>
                            <div className="flex justify-center mb-5">
                                <UserIcon className="p-2 h-28 w-28 bg-orange-500 rounded-full text-white" />
                            </div>
                            {showError &&
                                <div className='text-red-700 rounded-xl p-1 mb-3'>                                                                        
                                    {errorMsg}                                    
                                </div>
                            }
                            <div className="mb-4 h-10">                           
                                <div className='flex items-center border-b-2'>
                                    <EnvelopeIcon className='text-gray-300' width={20} height={20}></EnvelopeIcon>
                                    <input className="ml-3 focus:outline-none" id="username" ref={username} type="text" placeholder="email" />
                                </div>                        
                            </div>
                            <div className="mb-6 h-10">                           
                                <div className='flex border-b-2 items-center'>
                                    <LockClosedIcon className='text-gray-300' width={20} height={20}></LockClosedIcon>
                                    <input className="ml-3 focus:outline-none" id="password" ref={password} type="password" placeholder="password" />
                                </div>  
                                <div className='mt-1 text-right'>
                                    <label className='text-xs italic text-gray-500 underline cursor-pointer hover:text-blue-400'>Forgot password?</label>  
                                </div>                                               
                            </div>                        
                            <div className='flex mt-1'>                            
                                <button type="submit" className="flex-grow text-center text-white p-2 bg-orange-500 rounded-xl hover:bg-orange-600">LOGIN</button>
                            </div>                                                                   
                            <div className='mt-1'>
                                {loading  &&
                                    
                                    <LinearProgress></LinearProgress>
                                }
                            </div>
                        </form>                       
                        <div className='mt-2 text-center font-light text-xs text-gray-400'>Copy Rights (c) Softrend Systems Inc.</div>
                    </div>           
                </div> 
            </div>                                      
        </div>        
    )
}
export default Login
